// @flow
import React, {PureComponent} from 'react';
import {
  LayoutAnimation,
  Platform,
  StyleSheet,
  TouchableWithoutFeedback,
  View,
} from 'react-native';
import {Link, Text} from 'trpc-react-native-ui';
import {ConfirmationModal, Icon} from '../../../components/common';
import BaseFrame from '../../../components/common/Frame/BaseFrame';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';

const isAndroid = Platform.OS === 'android';

class CollapsibleFrame extends PureComponent<Props, State> {
  state: State = {isOpen: false};

  styles = getStyles();

  UNSAFE_componentWillUpdate(nextProps: Props, nextState: State) {
    if (nextState.isOpen === this.state.isOpen) {
      return;
    }

    const animation = isAndroid
      ? {
          duration: 200,
          update: {
            type: 'easeInEaseOut',
          },
        }
      : {
          duration: 600,
          update: {
            type: 'spring',
            springDamping: 0.7,
          },
        };

    LayoutAnimation.configureNext(animation);
  }

  toggle = () => {
    this.setState(state => ({
      isOpen: !state.isOpen,
    }));
  };

  render() {
    const styles = this.styles;
    const {children = null, getCollapsibleContent = () => {}} = this.props;
    const chevronRotateStyle = this.state.isOpen ? styles.chevronOpened : null;
    return (
      <BaseFrame style={this.props.style}>
        <TouchableWithoutFeedback onPress={this.toggle}>
          <View>
            {children}
            <View
              style={[
                styles.collapsiblePanelContainer,
                !this.state.isOpen && styles.collapsiblePanelContainerClosed,
              ]}>
              {getCollapsibleContent()}
            </View>
            <View style={styles.bottomContainer}>
              {this.props.onDismiss && (
                <ConfirmationModal
                  openModalText={I18n.t('Dashboard.Orders.dismiss')}
                  onConfirm={this.props.onDismiss}
                  confirmContent={this.props.dismissModalContent}
                  ButtonComponent={
                    <Link
                      displayRightArrow={false}
                      style={styles.chevronText}
                    />
                  }
                />
              )}
              <View style={styles.chevronContainer}>
                <Text style={styles.chevronText}>
                  {this.state.isOpen
                    ? I18n.t('Dashboard.Orders.less')
                    : I18n.t('Dashboard.Orders.more')}
                </Text>
                <Icon
                  size={14}
                  name="arrow-down"
                  style={[styles.chevron, chevronRotateStyle]}
                />
              </View>
            </View>
          </View>
        </TouchableWithoutFeedback>
      </BaseFrame>
    );
  }
}

type Props = {
  children: any,
  getCollapsibleContent: () => any,
  style?: any,
  onDismiss?: Function,
  dismissModalContent?: string,
};

type DefaultProps = $Shape<Props>;

type State = {
  isOpen: boolean,
};

const getStyles = () =>
  StyleSheet.create({
    bottomContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      backgroundColor: theme.frame.backgroundColor,
      paddingTop: 5,
    },
    chevronContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    collapsiblePanelContainer: {
      overflow: 'hidden',
    },
    collapsiblePanelContainerClosed: {
      height: 0,
    },
    chevronText: {
      textAlign: 'right',
      fontSize: 14,
      color: theme.frame.linkColor,
    },
    chevron: {
      color: theme.frame.linkColor,
      paddingHorizontal: 8,
      marginTop: 3,
    },
    chevronOpened: {
      transform: [{rotate: '180deg'}],
    },
  });

export default CollapsibleFrame;
